import React from 'react';
import { IconBase } from '../Base';
export const IconSend = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M12.4342 15.9825L16.6 4.74499C16.91 3.90749 16.095 3.09249 15.2575 3.40249L4.01501 7.57166C3.05251 7.92833 3.12835 9.31333 4.12335 9.56333L9.17918 10.8333L10.4417 15.8733C10.6908 16.8692 12.0767 16.9458 12.4342 15.9825V15.9825Z", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Send.js.map